// extracted by mini-css-extract-plugin
export var priceSectionBox = "priceSection-module--priceSectionBox--SvBzI";
export var peiceSectionHeadText = "priceSection-module--peiceSectionHeadText--394e5";
export var peiceSectionSubHeadText = "priceSection-module--peiceSectionSubHeadText--MDGI1";
export var priceSectionBottomImage = "priceSection-module--priceSectionBottomImage--LmcZQ";